import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeader } from "@/components/Reveal";
import { GalleryGrid } from "@/components/GalleryGrid";
import { Seo } from "@/components/Seo";
import { crumbs } from "@/config/seo";

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="pt-32">
      <Seo
        title="Metal Print Gallery — Anime, Portraits, Pets & Custom Art | MetalMuse"
        description="Browse MetalMuse metal print samples across family portraits, couples, pets, cars, anime, memorials and landscapes. Every photo deserves metal — yours will look even better."
        path="/gallery"
        keywords="metal print gallery, anime metal art, pet portrait metal print, custom metal photo examples, Saskatchewan"
        jsonLd={[crumbs([{ name: 'Home', path: '/' }, { name: 'Gallery', path: '/gallery' }])]}
      />
      <section className="container-lux pb-24">
        <SectionHeader eyebrow="Gallery" title="Every photo deserves metal" text="Browse by category. These are sample images — yours will look even better. Tap any image to view it full-screen." />
        <GalleryGrid />
      </section>
      <section className="bg-[#0A0A0A] border-t border-white/5 py-20">
        <div className="container-lux text-center">
          <Reveal>
            <h2 className="font-tech text-3xl md:text-4xl text-[#F5F5F7]">Your photo could be next</h2>
            <Link to="/order" data-testid="gallery-bottom-cta" className="mt-8 inline-flex items-center gap-2 bg-white text-black font-tech text-xs uppercase tracking-[0.2em] font-semibold px-8 py-4 rounded-full hover:bg-cyan-200 transition-[background-color,box-shadow,transform] duration-300 shadow-[0_0_20px_rgba(0,229,255,0.3)] hover:-translate-y-1">
              Order Your Metal Print <ArrowRight size={18} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
